import type { ThemeOptions } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import deepmerge from "deepmerge";


const theme = {
	create: createTheme,
	merge: (base: ThemeOptions, second: ThemeOptions) => createTheme(deepmerge(base, second))
};

const is = {
	undefined: (value: unknown) => typeof value === "undefined",
	string: (value: unknown): value is string => typeof value === "string",
	file: (value: unknown): value is File => value instanceof File
};

const toBase64 = (file: File): Promise<string | ArrayBuffer | null> => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = () => resolve(reader.result);
	reader.onerror = reject;
});

const prefetch = (url: string) => {
	const link = document.createElement("link");
	link.rel = "prefetch";
	link.href = url;
	document.head.appendChild(link);
};

const scrollTo = (selector: string) => {
	const invalidElement = window.document.querySelector(selector);
	invalidElement?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
};

export default {
	is,
	theme,
	prefetch,
	toBase64,
	scrollTo
};